import { DataService } from "base/services";

import { getApiBaseUrl } from "../utils/service.utils.js";

const NOTIFICATION_SERVICE = "notification";

export const AdminNotificationService = {
  getAdminConfiguredNotifications() {
    const url = getApiBaseUrl(NOTIFICATION_SERVICE);
    return DataService.get(`${url}/admin/notice/list`);
  },
  setConfiguredAdminNotices({ noticeId, payload, noticeType }) {
    let url = getApiBaseUrl(NOTIFICATION_SERVICE);
    return DataService.update(
      `${url}/admin/notice/${noticeId}?_type=${noticeType}`,
      { data: payload }
    );
  }
};
